module.exports = __webpack_public_path__ + "img/icon_wy02.dff79f40.png";